import { create } from 'zustand'
import type {} from '@redux-devtools/extension' // required for devtools typing
import { devtools } from 'zustand/middleware'
import { createRef, type RefObject } from 'react'
import { createEventEmitter, EventEmitter } from '@bpinternal/shared'

type Events = {
  [key: string]: string
}

type WebchatStore = {
  messageContainerRef: RefObject<HTMLDivElement>
  setMessageContainerRef: (ref: RefObject<HTMLDivElement>) => void
  portalContainer: HTMLElement | null
  setPortalContainer: (container: HTMLElement | null) => void
  eventEmitter: EventEmitter<Events>
}

export const useWebchatStore = create<WebchatStore>()(
  devtools(
    (set) => ({
      eventEmitter: createEventEmitter<Events>(),
      messageContainerRef: createRef<HTMLDivElement>(),
      setMessageContainerRef: (ref: RefObject<HTMLDivElement>) => set({ messageContainerRef: ref }),
      portalContainer: null,
      setPortalContainer: (container: HTMLElement | null) => set({ portalContainer: container }),
    }),
    { name: 'webchatStore' }
  )
)
